/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFRankingItem
 */
export interface CRSFRankingItem {
    /**
     * 
     * @type {number}
     * @memberof CRSFRankingItem
     */
    month: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFRankingItem
     */
    rank: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFRankingItem
     */
    year: number;
}

/**
 * Check if a given object implements the CRSFRankingItem interface.
 */
export function instanceOfCRSFRankingItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "month" in value;
    isInstance = isInstance && "rank" in value;
    isInstance = isInstance && "year" in value;

    return isInstance;
}

export function CRSFRankingItemFromJSON(json: any): CRSFRankingItem {
    return CRSFRankingItemFromJSONTyped(json, false);
}

export function CRSFRankingItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFRankingItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'month': json['month'],
        'rank': json['rank'],
        'year': json['year'],
    };
}

export function CRSFRankingItemToJSON(value?: CRSFRankingItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'month': value.month,
        'rank': value.rank,
        'year': value.year,
    };
}

